import React from 'react';
import { Row, Col, Card, Descriptions } from 'antd';
const MoreTableData = ({ record }) => {
  
  return (
    <Row>
      <Col span={11} className='m-1'>
        <Card style={{ height: "auto" }}>
          <Row gutter={[3, 3]} className='text-center'>
            <Col span={24} >
              <Descriptions bordered size='small'  >
                <Descriptions.Item labelStyle={{ 'width': 170 }}  contentStyle={{ 'width': 500 }} label="Math plan type" text="center" span={2}>{record.Math_plan_type}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
          <Row gutter={[3, 3]} className='text-center'>
            <Col span={24} >
              <Descriptions bordered size='small' className='text-center'  >
                <Descriptions.Item labelStyle={{ 'width': 170 }} contentStyle={{ 'width': 500 }} label="CLcode" span={2}>{record.CL_code}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span={12} className='m-1' >
        <Card style={{ height: 'auto' }}>
        <Row gutter={[3, 3]} className='text-center'>
            <Col span={24} >
              <Descriptions bordered size='small'  >
                <Descriptions.Item labelStyle={{ 'width': 170 }} contentStyle={{ 'width': 500 }} label="English plan type" text="center" span={2}>{record.English_plan_type}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
          <Row gutter={[3, 3]} className='text-center'>
            <Col span={24} >
              <Descriptions bordered size='small'  >
                <Descriptions.Item labelStyle={{ 'width': 170 }} contentStyle={{ 'width': 500 }} label="Student name" span={2}>{record.Student_name}</Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

  )
}
export default MoreTableData
